/**
 * Curated essential items for inventory Add Item combobox.
 * Categories are display-only; we store only item_name (string).
 */

export const ESSENTIALS_BY_CATEGORY: { category: string; items: string[] }[] = [
  {
    category: "Kitchen – Consumables",
    items: [
      "Paper towels", "Napkins", "Dish soap", "Hand soap (kitchen)", "Dishwasher pods", "Sponges", "Scrub brush",
      "Trash bags", "Compost bags", "Aluminum foil", "Plastic wrap", "Parchment paper", "Zip-top bags (sandwich)",
      "Zip-top bags (gallon)", "Cling wrap", "Coffee pods", "Ground coffee", "Coffee filters", "Tea bags", "Hot chocolate",
      "Sugar", "Salt", "Pepper", "Olive oil", "Cooking oil (neutral)", "Vinegar", "Dish towels", "All-purpose cleaner (kitchen)",
    ],
  },
  {
    category: "Kitchen – Tools/Utensils",
    items: [
      "Cutting board", "Knife set", "Chef knife", "Paring knife", "Can opener", "Bottle opener", "Corkscrew",
      "Measuring cups", "Measuring spoons", "Mixing bowls", "Colander/strainer", "Baking sheet", "Oven mitts", "Tongs",
      "Spatula", "Wooden spoon", "Ladle", "Whisk", "Grater", "Peeler", "Kitchen shears", "Food storage containers",
      "Ice cube tray", "Water pitcher", "Wine glasses", "Drinking glasses", "Mugs", "Plates", "Bowls", "Forks",
      "Knives (cutlery)", "Spoons", "Serving spoon", "Serving tongs",
    ],
  },
  {
    category: "Kitchen – Appliances/Durable",
    items: [
      "Coffee machine", "Kettle", "Toaster", "Microwave", "Blender", "Air fryer", "Rice cooker", "Dishwasher",
      "Refrigerator", "Stove/oven", "Range hood", "Vacuum sealer",
    ],
  },
  {
    category: "Bathroom – Consumables",
    items: [
      "Toilet paper", "Facial tissues", "Paper towels (bathroom backup)", "Hand soap (bathroom)", "Shampoo", "Conditioner",
      "Body wash", "Bar soap", "Lotion", "Makeup remover wipes", "Cotton swabs", "Cotton pads", "Toothpaste", "Mouthwash",
      "Disposable razors", "Shaving cream", "Feminine products", "Air freshener", "Disinfecting wipes", "Bathroom cleaner",
      "Glass cleaner", "Toilet bowl cleaner",
    ],
  },
  {
    category: "Bathroom – Tools/Durable",
    items: [
      "Plunger", "Toilet brush", "Hair dryer", "First aid kit", "Extra toothbrushes", "Scale", "Shower curtain liner", "Bath mat",
    ],
  },
  {
    category: "Laundry / Cleaning – Consumables",
    items: [
      "Laundry detergent", "Dryer sheets", "Fabric softener", "Stain remover", "Bleach", "Disinfectant spray",
      "All-purpose cleaner", "Glass cleaner", "Floor cleaner", "Wood cleaner/polish", "Oven cleaner", "Stainless steel cleaner",
      "Microfiber cloths", "Paper towels", "Sponges",
    ],
  },
  {
    category: "Laundry / Cleaning – Tools/Durable",
    items: [
      "Broom", "Dustpan", "Mop", "Bucket", "Vacuum", "Handheld vacuum", "Duster", "Lint roller", "Rubber gloves", "Squeegee", "Step stool",
    ],
  },
  {
    category: "Bedroom / Linens",
    items: [
      "Bath towels", "Hand towels", "Washcloths", "Beach towels", "Bed sheets (Twin)", "Bed sheets (Full)", "Bed sheets (Queen)",
      "Bed sheets (King)", "Pillowcases", "Pillows", "Extra pillows", "Blankets", "Comforter", "Duvet cover", "Mattress protector",
      "Hangers", "Iron", "Ironing board",
    ],
  },
  {
    category: "Living / General",
    items: [
      "Wi-Fi router", "TV remote", "Streaming device (Chromecast/Roku)", "HDMI cable", "Extension cord", "Power strip",
      "Phone chargers (USB-C)", "Phone chargers (Lightning)", "Batteries (AA)", "Batteries (AAA)", "Light bulbs", "Flashlight",
      "Umbrella", "Tool kit (basic)", "Scissors", "Tape measure", "Pens", "Notepad",
    ],
  },
  {
    category: "Entry / Outdoor",
    items: ["Doormat", "Key set / spare keys", "Snow shovel", "Ice melt", "BBQ tools", "Propane tank"],
  },
  {
    category: "Safety",
    items: ["Fire extinguisher", "Smoke detector (battery)", "Carbon monoxide detector (battery)", "Emergency contact sheet"],
  },
];

/** Flat list of all essential item names for the combobox (order preserved with category grouping in UI). */
export const ESSENTIAL_ITEM_NAMES = ESSENTIALS_BY_CATEGORY.flatMap((g) => g.items);

/** Set of item names that are liquids (for auto-detecting "Liquid item" and preselecting Fullness). */
export const LIQUID_ITEM_NAMES = new Set([
  "Dish soap", "Hand soap (kitchen)", "Hand soap (bathroom)", "Shampoo", "Conditioner", "Body wash", "Lotion", "Mouthwash",
  "Cooking oil (neutral)", "Olive oil", "Vinegar", "Laundry detergent", "Fabric softener", "Bleach", "Disinfectant spray",
  "Glass cleaner", "All-purpose cleaner (kitchen)", "All-purpose cleaner", "Floor cleaner", "Air freshener",
  "Dishwasher rinse aid",
]);

export function isLiquidItem(itemName: string): boolean {
  return LIQUID_ITEM_NAMES.has(itemName.trim());
}
